import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";

var _Getters;

import * as types from "@/store/constants/types";
var Getters = (_Getters = {}, _defineProperty(_Getters, types.GETTER_TOAST, function (state, payLoad) {
  return state.toastData;
}), _defineProperty(_Getters, types.GETTER_LOADING_STATUS, function (state, payLoad) {
  return state.showLoaing;
}), _Getters);
export default Getters;